import React from 'react';
import { motion } from 'framer-motion';
const modules = [{
  n: '01',
  emoji: '⛩️',
  color: 'rose',
  title: 'Los orígenes del irezumi',
  desc: 'Historia, tradición y evolución.',
  image: 'https://cdn.magicpatterns.com/uploads/33UxekBLhdBoxDDeukSP9U/modulo_1_(5).png',
  highlights: ['Orígenes del tatuaje en Japón', 'El período Edo y el Ukiyo-e', 'La prohibición y la clandestinidad', 'La evolución del estilo', 'El irezumi en la actualidad']
}, {
  n: '02',
  emoji: '🐉',
  color: 'gold',
  title: 'Símbolos fundamentales',
  desc: 'Dragones, koi, tigres, serpientes y más.',
  image: 'https://cdn.magicpatterns.com/uploads/oCZWrGs1LBF94TmGLYcT8J/modulo_2_(1).png',
  highlights: ['El dragón (Ryu) y su poder', 'La carpa (Koi) y la perseverancia', 'El tigre (Tora) y el coraje', 'La serpiente (Hebi) y la sabiduría', 'Combinaciones clásicas']
}, {
  n: '03',
  emoji: '🌸',
  color: 'rose',
  title: 'Flores y elementos',
  desc: 'Sakura, peonías, olas, fuego, viento y composición.',
  image: 'https://cdn.magicpatterns.com/uploads/dFPrPvLCPzrvgwjiWGnftG/modulo_3_(1).png',
  highlights: ['La flor de cerezo (Sakura)', 'La peonía (Botan)', 'El crisantemo (Kiku)', 'El agua (Mizu) y las olas', 'El viento (Kaze) y el fuego']
}, {
  n: '04',
  emoji: '👺',
  color: 'gold',
  title: 'Máscaras y mitología',
  desc: 'Hannya, Oni, Kitsune, Tengu y Yokai.',
  image: 'https://cdn.magicpatterns.com/uploads/1A7UPAjBoEZBMwi6BbJo2C/modulo_4_(1).png',
  highlights: ['La máscara Hannya y los celos', 'Los demonios Oni', 'El zorro de nueve colas (Kitsune)', 'Los espíritus Tengu', 'El mundo de los Yokai']
}, {
  n: '05',
  emoji: '👘',
  color: 'rose',
  title: 'La construcción del irezumi',
  desc: 'Mangas, espaldas, body suits y narrativa corporal.',
  image: 'https://cdn.magicpatterns.com/uploads/tx4c79mapfobpntkinPGoz/modulo_5_(1).png',
  highlights: ['Estructura de un traje completo', 'El fondo (Gakubori)', 'Las reglas de composición', 'La narrativa visual', 'El equilibrio y el flujo']
}, {
  n: '06',
  emoji: '🖋️',
  color: 'gold',
  title: 'Antes de hacerte un tatuaje japonés',
  desc: 'Símbolos, tatuadores, errores y composición.',
  image: 'https://cdn.magicpatterns.com/uploads/75v7JsfpU28fnAMn4RB3o5/modulo_6_(1).png',
  highlights: ['Cómo elegir un diseño', 'Errores comunes a evitar', 'La importancia del fondo', 'Encontrar al artista adecuado', 'El compromiso del irezumi']
}, {
  n: '07',
  emoji: '🖼️',
  color: 'rose',
  title: 'Galería maestra',
  desc: 'Composiciones legendarias y ejemplos visuales.',
  image: 'https://cdn.magicpatterns.com/uploads/2j4NhKorkjuHPmK3pPBeJn/modulo_7_(1).png',
  highlights: ['Obras maestras históricas', 'Espaldas completas', 'Mangas y piernas', 'Detalles y texturas', 'Inspiración visual']
}, {
  n: '08',
  emoji: '📜',
  color: 'gold',
  title: 'El legado del irezumi',
  desc: 'Tradición, identidad y evolución.',
  image: 'https://cdn.magicpatterns.com/uploads/pgNPLRkppuHeApXYu9LVS7/modulo_8_(1).png',
  highlights: ['El impacto global', 'La preservación del arte', 'El irezumi moderno', 'La identidad cultural', 'El futuro del tatuaje japonés']
}];
export function ModulesSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-213">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-214">
            <span className="text-xs font-bold tracking-widest" data-id="element-215">
              🌸 8 MÓDULOS COMPLETOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-216">
            Más de 150 páginas.{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-217">
              Todo organizado.
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-218">
          {modules.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} className="bg-bg-soft border border-line rounded-3xl shadow-sm hover:shadow-xl hover:shadow-rose/10 transition-all overflow-hidden flex flex-col" data-id="element-219">
              {m.image && <div className="relative aspect-[3/4] w-full bg-bg overflow-hidden" data-id="element-220">
                  <img src={m.image} alt={`Módulo ${m.n} — ${m.title}`} className="w-full h-full object-cover" data-id="element-221" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-222" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6" data-id="element-223">
                    <div className="text-[11px] font-bold text-rose tracking-widest mb-1 drop-shadow" data-id="element-224">
                      MÓDULO {m.n}
                    </div>
                    <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink leading-tight uppercase drop-shadow-lg" data-id="element-225">
                      {m.title}
                    </h3>
                  </div>
                </div>}
              <div className="p-6 md:p-7 flex-1 flex flex-col" data-id="element-226">
                {!m.image && <div className="flex items-start gap-4 mb-4" data-id="element-227">
                    <div className={`flex-shrink-0 w-14 h-14 rounded-2xl flex items-center justify-center text-2xl ${m.color === 'rose' ? 'bg-rose/15' : 'bg-gold/15'}`} data-id="element-228">
                      {m.emoji}
                    </div>
                    <div className="flex-1" data-id="element-229">
                      <div className={`text-xs font-bold tracking-widest mb-1 ${m.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-230">
                        MÓDULO {m.n}
                      </div>
                      <h3 className="font-serif font-bold text-xl md:text-2xl text-ink leading-tight uppercase" data-id="element-231">
                        {m.title}
                      </h3>
                    </div>
                  </div>}
                <p className="text-ink-soft text-sm md:text-base leading-relaxed mb-4" data-id="element-232">
                  {m.desc}
                </p>
                <ul className="space-y-1.5 border-t border-line pt-4" data-id="element-233">
                  {m.highlights.map((h, j) => <li key={j} className="text-sm text-ink-soft flex items-start gap-2" data-id="element-234">
                      <span className="text-rose mt-0.5" data-id="element-235">🌸</span>
                      {h}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}